import { useQuery } from '@tanstack/react-query';

import { TeamSyncBackends } from '@graylog/enterprise-api';

import type { SAMLTeamSyncBackend } from 'authentication/components/saml/config/helpers/samlConfigConverter';

type Response = {
  backend: SAMLTeamSyncBackend;
};

const fetch = (backendId: string) => TeamSyncBackends.get(backendId) as Promise<Response>;

const useSAMLTeamSyncConfig = (backendId: string) => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ['saml.team.sync.backend'],
    queryFn: () => fetch(backendId),
    retry: false,
  });

  if (isError) {
    // Our generated API client doesn't allow the inspection of the response status. Otherwise, we could create
    // a user notification here if the error is not a 404.
    return { isLoading: false, teamSyncBackend: undefined };
  }

  return { isLoading, teamSyncBackend: data?.backend };
};

export default useSAMLTeamSyncConfig;
